import { render, staticRenderFns } from "./import-details-dialog.vue?vue&type=template&id=7931523c&scoped=true&"
import script from "./import-details-dialog.vue?vue&type=script&lang=js&"
export * from "./import-details-dialog.vue?vue&type=script&lang=js&"
import style0 from "./import-details-dialog.vue?vue&type=style&index=0&id=7931523c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931523c",
  null
  
)

export default component.exports